import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    controlContainer: {
      marginTop: 10,
      marginLeft: -11,
    },
    checkboxRoot: {
      marginRight: 8,
      '&:last-child': {
        marginRight: 0,
      },
      [breakpoints.down(500)]: {
        marginRight: 0,
        width: '50%',
      },
    },
    checkboxRootVerticalDirection: {
      [breakpoints.down(500)]: {
        width: '100%',
      },
    },
    boxRoot: {
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      color: custom.grey[2],
      paddingRight: 4,
      '> *': {
        cursor: 'pointer',
      },
    },
    boldText: {
      fontWeight: 'bold',
    },
    verticalDirection: {
      paddingTop: 3,
      paddingBottom: 3,
    },
    active: {
      borderColor: palette.primary.main,
      color: palette.primary.main,
      '&:hover': {
        borderColor: palette.primary.main,
      },
    },
    label: {
      cursor: 'pointer',
    },
    disabled: {
      cursor: 'not-allowed',
      '& *': {
        pointerEvents: 'none',
      },
    },
  })
);
